module.exports = __webpack_public_path__ + "img/icon-5.7f3bf5c4.svg";